/* Collapsible storefront filter groups. Adds a toggle to each filter heading without moving or re-creating
   any input, so the theme's filtering, slider and "show more" keep working. */
(function () {
  /* the grid/list switch is removed: always show the grid, and drop any saved list preference */
  try { if (localStorage.getItem('ee-view') === 'list') localStorage.setItem('ee-view', 'grid'); } catch (e) {}
  var coll = document.getElementById('collection'); if (coll && coll.dataset.view === 'list') coll.dataset.view = 'grid';
  var KEY = 'ee-filter-closed';
  function read() { try { return JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(a) { try { sessionStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }

  function groupOf(h) {
    var out = [], n = h.nextElementSibling;
    while (n && n.tagName !== 'H4' && !n.classList.contains('submit')) { out.push(n); n = n.nextElementSibling; }
    return out;
  }

  function badge(h, grp) {
    var n = 0;
    grp.forEach(function (el) { n += el.querySelectorAll('input[type="checkbox"]:checked').length; });
    var b = h.querySelector('.ee-fcount');
    if (!n) { if (b) b.remove(); return; }
    if (!b) { b = document.createElement('span'); b.className = 'ee-fcount'; h.insertBefore(b, h.querySelector('.header-toggle')); }
    b.textContent = n;
  }

  function setOpen(h, grp, open) {
    h.classList.toggle('is-closed', !open);
    h.setAttribute('aria-expanded', open ? 'true' : 'false');
    grp.forEach(function (el) { el.classList.toggle('ee-gc', !open); });
  }

  function enhance(form) {
    if (form.dataset.eeFold) return;
    var fs = form.querySelector('fieldset');
    if (!fs) return;
    form.dataset.eeFold = '1';
    var closed = read();
    [].slice.call(fs.querySelectorAll(':scope > h4[data-filter-toggle]')).forEach(function (h) {
      var key = h.getAttribute('data-filter-toggle'), grp = groupOf(h);
      grp.forEach(function (el) { el.setAttribute('data-ee-g', key); });
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      var has = grp.some(function (el) { return el.querySelector('input:checked'); });
      setOpen(h, grp, !(closed.indexOf(key) > -1 && !has));
      badge(h, grp);
      function flip() {
        var open = h.classList.contains('is-closed');
        setOpen(h, grp, open);
        var c = read().filter(function (k) { return k !== key; });
        if (!open) c.push(key);
        write(c);
      }
      h.addEventListener('click', function (e) { if (e.target.closest('a')) return; flip(); });
      h.addEventListener('keydown', function (e) { if (e.target !== h) return; if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
      form.addEventListener('change', function () { badge(h, grp); });
    });
  }

  function scan() { [].forEach.call(document.querySelectorAll('form.f8fl'), enhance); }
  scan();
  new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
})();
